export const SelectIndicator = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 11">
      <path
        id="Polygon 4"
        d="M9.20502 12.9639C9.34599 13.1732 9.65401 13.1732 9.79498 12.9639L13.4387 7.55435C13.5978 7.31811 13.4286 7 13.1437 7H5.85626C5.57143 7 5.40216 7.31811 5.56128 7.55435L9.20502 12.9639Z"
        fill="white"
      />
    </g>
  </svg>
);
